import { INITIAL_RISK_FIELD_KEY, RESIDUAL_RISK_FIELD_KEY, TARGET_RISK_FIELD_KEY } from './constants';

export type PanelGating = {
  showsScoringPanel: boolean;
  isDrawnByPanel: (fieldKey: string) => boolean;
  isPanelAnchor: (fieldKey: string) => boolean;
};

export const getPanelGating = (fieldOrder: string[]): PanelGating => {
  const keys = new Set(fieldOrder);
  const showsScoringPanel = keys.has(INITIAL_RISK_FIELD_KEY) && keys.has(RESIDUAL_RISK_FIELD_KEY);

  return {
    showsScoringPanel,
    isDrawnByPanel: (fieldKey) =>
      showsScoringPanel && (fieldKey === RESIDUAL_RISK_FIELD_KEY || fieldKey === TARGET_RISK_FIELD_KEY),
    isPanelAnchor: (fieldKey) => showsScoringPanel && fieldKey === INITIAL_RISK_FIELD_KEY,
  };
};
